export enum FilterAreaType {
  group = 'group',
  user = 'user'
}